module.exports = __webpack_public_path__ + "static/media/Caminho49.6ad90f16.svg";